import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import useSWR from "swr";
import { API } from "../../StoreComponents/conflict";
import NotFoundPage from "../../StoreComponents/NotFoundPage";

const fetcher = (url) => API.get(url).then((res) => res.data.data);
const StockLess = () => {
  // print
  const navigate = useNavigate();
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  // get Stockless Product Data
  const {
    data: allStockLess,
    error,
    mutate,
  } = useSWR(`store/warehouse/stockAlert`, fetcher);
  console.log("allStockLess", allStockLess);

  return (
    <>
      <Helmet>
        <title>Stock Less - BBA STORE</title>
        <meta name="description" content="Stock Less - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>
      <div className="page-wrapper">
        <div className="d-flex justify-content-between">
          <div>
            <button
              onClick={() => navigate(-1)}
              className="btn btn-o ms-1 mb-3"
              style={{
                background: "#000",
                color: "#fff",
                borderRadius: "10px",
              }}
            >
              <i className="fa fa-hand-o-left"></i> Back
            </button>
          </div>
          <div>
            <button
              onClick={handlePrint}
              type="button"
              className="btn btn-color px-3 printBtn show ms-auto my-3 me-2 "
            >
              <i className="fa fa-print"></i>
              <span> Print</span>
            </button>
          </div>
        </div>

        {!allStockLess ? (
          <NotFoundPage />
        ) : (
          <section ref={componentRef} className=" mx-3 py-3">
            <div>
              <div className="text-center mt-4 mb-5">
                <div>
                  <h4>
                    <b>INFOTECH IT SOLUTIONS</b>
                  </h4>

                  <h4>Stock Less Products</h4>
                </div>
              </div>
              <div className="table-responsive-sm">
                <table className="table table-bordered table-striped boder">
                  <thead>
                    <tr className="text-center">
                      <th colSpan="1">S/N</th>
                      <th colSpan="1">CATEGORY</th>
                      <th colSpan="1">PRODUCT</th>
                      <th colSpan="1">ALERT QTY</th>
                      <th colSpan="1">STOCK QTY</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allStockLess.map((product, index) => (
                      <tr key={index}>
                        <th className="text-center" colSpan="1">
                          {index + 1}
                        </th>
                        <td colSpan="1">{product.CATEGORYEN}</td>
                        <td colSpan="1">
                          {product.PRONAMETWO} <br /> ({product.PRONAME})
                        </td>
                        <td colSpan="1" className="text-center">
                          {product.STOCKALERT}
                        </td>
                        <td colSpan="1" className="text-center text-danger">
                          {product.PROQTY}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default StockLess;
